import { createFileRoute, notFound } from "@tanstack/react-router";
import { siteTitle, siteUrl } from "@/config/site";
import { cardMeta } from "@/lib/social-card-meta";
import { getStaticPageBody } from "@/lib/pages";
import { readLocale } from "@/lib/route-head";
import { StaticMdxPage } from "@/components/static-mdx-page";

const SLUG = "terms-of-service";
/** Pre-loader fallback only; the live copy is the page's own frontmatter. */
const FALLBACK_TITLE = "Terms of Service";

export const Route = createFileRoute("/($locale)/terms-of-service")({
  loader: async ({ params }) => {
    try {
      return await getStaticPageBody({
        data: { slug: SLUG, locale: readLocale(params) },
      });
    } catch {
      throw notFound();
    }
  },
  head: ({ loaderData, params }) => {
    const meta = loaderData?.meta;
    const canonicalUrl = `${siteUrl}/terms-of-service`;
    // Both card headlines use the page's own title, without the
    // `" | Beancount.io"` suffix the <title> carries (w3/m21).
    const title = meta?.title ?? FALLBACK_TITLE;
    const description = meta?.description ?? "";
    return {
      meta: [
        { title: `${title} | ${siteTitle}` },
        { name: "description", content: description },
        ...cardMeta({
          title,
          description,
          canonicalUrl,
          locale: readLocale(params),
        }),
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  component: function TermsRoute() {
    const { code } = Route.useLoaderData();
    return <StaticMdxPage code={code} />;
  },
});
